import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/HelveticaNowDisplay-Light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/HelveticaNowDisplay-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/HelveticaNowDisplay-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}]}],%22variableName%22:%22helveticanow%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'helveticanow', 'helveticanow Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
